<template>
  <div class="user-menu">
    <v-menu
      location="bottom" offset="12" rounded="lg"
      class="rounded-lg"
      :width="200"
    >
      <template #activator="{ props }">
        <BrandButton
          icon variant="text" class="pa-0"
          height="48" width="48" v-bind="props"
        >
          <UserAvatar :user="user" />
        </BrandButton>
      </template>

      <v-list bg-color="neutral0">
        <v-list-item to="/account">
          <v-list-item-title>{{ t('layout.nav.account') }}</v-list-item-title>
        </v-list-item>
        <v-divider color="neutral50" />
        <v-list-item :href="helpUrl" target="_blank" rel="noopener">
          <v-list-item-title>{{ t('layout.nav.get_help') }}</v-list-item-title>
        </v-list-item>
        <v-list-item to="/auth/logout">
          <v-list-item-title>{{ t('cta.logout') }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

export default {
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const { t } = useI18n()

    const helpUrl = computed(() => {
      return `${CONFIG.landingpageUrl}${t('layout.nav.get_help.link')}`
    })

    return {
      t,
      helpUrl
    }
  }
}
</script>

<style lang="scss" scoped>
:deep(.v-avatar) {
  width: 48px;
  height: 48px;
}
</style>
